import { Modal } from "antd"

export const cannotRemoveOwnerModal = () => {
	Modal.error({
		title: "Cannot Remove Team Member",
		centered: true,
		content: "You cannot remove the owner of the podcast from the team!"
	})
}
